import React from 'react';
import PropTypes from 'prop-types';

import {publish} from '@stubhub/pubsub-utils';
import VirtualAssistantLazyLoad from '@stubhub/react-lazy-virtual-assistant';
import {connect} from '@stubhub/react-store-provider';

import {withUser} from '../../common/higherOrderComponents/withUser';
import {SELL_CHATBOT_EVENTS} from '../../tracking/track-enum';

import controller from './controller';

const projectID = process.env.REACT_APP_VOICE_FLOW_PROJECT_ID;

const VirtualAssistantWrapper = ({locale, userName}, {cookies}) => {
  const userGUID = cookies?.get('session_userGUID') || '';

  const handleChatbotOpen = () => {
    publish(SELL_CHATBOT_EVENTS.OPEN);

  };

  const handleChatbotClose = () => {
    publish(SELL_CHATBOT_EVENTS.CLOSE);
  };

  return (
    <VirtualAssistantLazyLoad
      type="VOICE_FLOW"
      projectID={projectID}
      userName={userName}
      GUID={userGUID}
      locale={locale}
      loadAutomatically={false}
      onOpen={handleChatbotOpen}
      onClose={handleChatbotClose}
    />
  );
};

VirtualAssistantWrapper.propTypes = {
  locale: PropTypes.string,
  userName: PropTypes.string
};

VirtualAssistantWrapper.contextTypes = {
  cookies: PropTypes.object
};

export default connect(controller)(withUser(VirtualAssistantWrapper, {wait: false}));
